export type CtaTarget =
  | { kind: 'internal'; routerLink: string }
  | { kind: 'external'; href: string }
  | { kind: 'contact'; href: string };

const SCHEME = /^[a-z][a-z0-9+.-]*:/i;

/**
 * Normalizes a CTA link typed into the admin panel. Returns null for anything
 * that is not safe to render as a link (e.g. `javascript:` / `data:` URLs).
 */
export const resolveCtaLink = (raw: string): CtaTarget | null => {
  const link = raw.trim();
  if (!link) return null;

  if (link.startsWith('//')) return { kind: 'external', href: `https:${link}` };
  if (link.startsWith('/')) return { kind: 'internal', routerLink: link };

  if (SCHEME.test(link)) {
    if (/^https?:/i.test(link)) return { kind: 'external', href: link };
    if (/^(mailto|tel):/i.test(link)) return { kind: 'contact', href: link };
    return null;
  }

  return { kind: 'external', href: `https://${link}` };
};
